﻿'use strict';

angular.module('ntmApp')
  .controller('cancelledActivitiesController', ['$scope', '$uibModalInstance', 'data', 'ConfirmationService', 'DailyPlanService', 'FlashService',
      function ($scope, $uibModalInstance, data, ConfirmationService, DailyPlanService, FlashService) {

          var init = function () {
              data.cancelledActivities.forEach(function (activity) {
                  activity.restore = false;
              });

              $scope.cancelledActivities = data.cancelledActivities;
              $scope.date = data.date;
              $scope.isPastDateDisplayed = data.isPastDateDisplayed;
              $scope.facilityCode = data.facilityCode;
              $scope.roomNumber = data.roomNumber;

              $scope.thereAreSomeCheckedActivitiesToRestore = false;
          };

          $scope.restoreActivities = function () {
              var request = {
                  date: $scope.date,
                  isPastDateDisplayed: $scope.isPastDateDisplayed,
                  facilityCode: $scope.facilityCode,
                  roomNumber: $scope.roomNumber ? $scope.roomNumber : null,
                  scheduleIds: []
              };

              var requestItems = $scope.cancelledActivities.filter(function (activity) {
                  return (activity.restore);
              });

              requestItems.forEach(function (item) {
                  request.scheduleIds.push(item.scheduleId);
              });

              //Restore ActivityAction
              request.activityActionType = 5;
              if (request.facilityCode === undefined) {
                  request.facilityCode = $scope.$resolve.data.cancelledActivities.find(function (element) {
                      return element.areaId !== undefined;
                  }).areaId;
              }

              var loadingModal = FlashService.Loading();
              DailyPlanService.SetGridRowActions(request).then(function (result) {
                  if (result.success) {
                      FlashService.Success(result.data.message);
                  }

                  loadingModal.dismiss();

                  $uibModalInstance.close(true);
              });
          };

          $scope.checkIfThereAreCheckedActivitiesToRestore = function () {
              $scope.thereAreSomeCheckedActivitiesToRestore = $scope.cancelledActivities.some(function (activity) {
                  return activity.restore;
              });
          };

          $scope.close = function (closeType) {
              $uibModalInstance.close(closeType || false);
          };

          $scope.dismiss = function () {
              $uibModalInstance.dismiss();
          };

          init();
      }]);